import { useState } from "react";
import type { MovieReview } from "@/types/content";

interface ReviewListProps {
  reviews: MovieReview[];
}

export default function ReviewList({ reviews }: ReviewListProps) {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? reviews : reviews.slice(0, 3);

  return (
    <div>
      <div className="space-y-4">
        {visible.map((review, i) => (
          <div
            key={`${review.user}-${i}`}
            className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
          >
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 text-sm font-semibold text-secondary-800">
                  {review.user.slice(0, 1)}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{review.user}</p>
                  <div className="flex items-center gap-0.5 text-accent-500">
                    {Array.from({ length: 5 }).map((_, idx) => (
                      <i
                        key={idx}
                        className={idx < Math.round(review.score / 2) ? "ri-star-fill text-xs" : "ri-star-line text-xs"}
                      />
                    ))}
                  </div>
                </div>
              </div>
              <span className="font-display text-lg font-bold text-primary-600">{review.score}.0</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{review.text}</p>
          </div>
        ))}
      </div>
      {reviews.length > 3 && (
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer"
        >
          {expanded ? "收起评论" : `展开更多评论（${reviews.length}）`}
          <i className={expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} />
        </button>
      )}
    </div>
  );
}